<div class="dlg-hdr">
  <div class="dlg-hdr__title">
    <div class="dlg-hdr__icon-wrap dlg-hdr__icon-wrap--red"><mat-icon>delete</mat-icon></div>
    <div>
      <span>Eliminar financiación propia</span>
      <small class="dlg-hdr__sub" *ngIf="response_message == null">Esta acción no se puede deshacer</small>
    </div>
  </div>
  <button mat-icon-button class="dlg-hdr__close" (click)="closeDialog()" aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dlg-body">
  <div class="delete-info" *ngIf="response_message == null">
    <mat-icon>warning</mat-icon>
    <div class="delete-info__text">
      ¿Seguro que quieres eliminar esta financiación? Esta acción es permanente.
    </div>
  </div>
  <div class="delete-info" [class.delete-info--success]="response_error === false" *ngIf="response_message != null">
    <mat-icon>{{ response_error === false ? 'check_circle' : 'error' }}</mat-icon>
    <div class="delete-info__text"><strong>{{ response_message }}</strong></div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dlg-actions">
  <button mat-stroked-button (click)="closeDialog()">
    <mat-icon>close</mat-icon> Cerrar
  </button>
  <button mat-flat-button class="dlg-btn-delete" (click)="delete()" *ngIf="response_message == null">
    <mat-icon>delete</mat-icon> Eliminar
  </button>
</mat-dialog-actions>
